var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-cascader", {
    staticStyle: { width: "280px" },
    attrs: {
      value: _vm.selectedPath,
      options: _vm.regions.options,
      props: { checkStrictly: true },
      placeholder: _vm.failed
        ? "地区加载失败，点击重试"
        : "请选择省 / 市 / 区，留空查全国",
      clearable: "",
      filterable: "",
    },
    on: { change: _vm.change, "visible-change": _vm.onVisible },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }